(function (host, factory) {
  'use strict';
  const library = factory();
  if (typeof module === 'object' && module.exports) module.exports = library;
  else if (host && host.document) {
    host.FASGardenUI?.dispose();
    host.FASGardenUI = library.createEngine(host);
  }
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  const ROOT = '[data-fas-garden]', ABOUT_HASH = '#sobre-nosotros';
  function createEngine(win) {
    const doc = win.document, instances = new Map(), cleanups = [];
    let disposed = false;
    function globalListener(target, name, callback) {
      target.addEventListener(name, callback);
      cleanups.push(() => target.removeEventListener(name, callback));
    }
    function rootsIn(scope) {
      return [...(scope.matches?.(ROOT) ? [scope] : []), ...scope.querySelectorAll(ROOT)];
    }
    function initialize(scope = doc) {
      if (disposed) return;
      rootsIn(scope).forEach(root => {
        if (instances.has(root)) return;
        const form = root.querySelector('[data-fas-form]');
        if (!form) return;
        const abort = new win.AbortController();
        const on = (element, type, callback, options = {}) => element?.addEventListener(type, callback, { ...options, signal: abort.signal });
        const clearDeselectedNote = event => {
          if (event.target?.name !== 'noteEnabled' || event.target.checked) return;
          const message = form.querySelector('[name="message"]');
          if (message) message.value = '';
        };
        on(form, 'input', clearDeselectedNote, {capture:true});
        on(form, 'change', clearDeselectedNote, {capture:true});
        const purchasePanel = root.querySelector('.fg-purchase-panel'), footer = root.querySelector('.fg-footer-links');
        const footerHome = footer?.parentNode, footerNext = footer?.nextSibling;
        const desktopLayout = win.matchMedia('(min-width: 1000px)');
        function restoreFooter() {
          if (footer && footerHome && footer.parentNode !== footerHome) footerHome.insertBefore(footer, footerNext?.parentNode === footerHome ? footerNext : null);
        }
        function placeFooter() {
          if (desktopLayout.matches && footer && purchasePanel) purchasePanel.appendChild(footer);
          else restoreFooter();
        }
        on(desktopLayout, 'change', placeFooter);
        placeFooter();
        const editor = root.querySelector('[data-fg-editor]');
        const info = root.querySelector('[data-fg-info-dialog]');
        const about = root.querySelector('[data-fg-about-dialog]');
        let trigger = null, editSnapshot = '', aboutReturnHash = '', scrollRevision = 0;
        let pointerScroll = null, noteReview = null;
        const done = editor?.querySelector('[data-fg-done]'), blank = editor?.querySelector('[data-fg-note-blank]');
        const doneMarkup = done?.innerHTML || '';
        function finishNoteReview(accepted) {
          if (!noteReview) return;
          const resolve = noteReview; noteReview = null;
          if (done) done.innerHTML = doneMarkup;
          if (blank) blank.hidden = true;
          const copy = editor?.querySelector('[data-fg-note-review-copy]'); if (copy) copy.hidden = true;
          resolve(accepted);
        }
        const modalScroll = new WeakMap();
        const titles = { letter1: 'Todo empieza por ti.', letter2: 'Y sigue con su inicial.', note: 'Palabras que se quedan.', offer: 'Un rincón a vuestra medida.', extras: 'Los detalles del regalo' };
        const snapshot = () => JSON.stringify(Array.from(new win.FormData(form)));
        function restoreScroll(position) {
          win.scrollTo?.({ left: position.x, top: position.y, behavior: 'instant' });
        }
        function restoreAfterFocus(position, revision, stillCurrent) {
          restoreScroll(position);
          // Native dialog focus can move the document again during the next layout.
          win.requestAnimationFrame(() => {
            if (!abort.signal.aborted && root.isConnected && revision === scrollRevision && stillCurrent()) restoreScroll(position);
          });
        }
        function closeAll() { root.querySelectorAll('dialog[open]').forEach(dialog => dialog.close()); }
        function setHash(hash) {
          const url = new URL(win.location.href);
          url.hash = hash;
          win.history.replaceState(win.history.state, '', url.pathname + url.search + url.hash);
        }
        function releaseAboutHash() {
          if (win.location.hash === ABOUT_HASH) setHash(aboutReturnHash);
        }
        function open(kind, button, updateHash = true, pointerClick = false) {
          const editing = Object.hasOwn(titles, kind);
          const target = kind === 'about' ? about : editing ? editor : info;
          if (!target) return;
          if (target.open && kind === 'about') return;
          const position = pointerClick && pointerScroll?.trigger === button
            ? pointerScroll.position : { x: win.scrollX || 0, y: win.scrollY || 0 };
          pointerScroll = null;
          if (kind !== 'about' && about?.open) releaseAboutHash();
          closeAll();
          const revision = ++scrollRevision;
          modalScroll.set(target, position);
          trigger = button || (kind === 'about' ? root.querySelector('[data-fg-open="about"]') : doc.activeElement);
          if (editing) {
            editor.querySelector('[data-fg-editor-title]').textContent = titles[kind];
            editor.querySelectorAll('[data-fg-panel]').forEach(panel => { panel.hidden = panel.dataset.fgPanel !== kind; });
          } else if (kind !== 'about') {
            const photos = kind === 'photos';
            info.querySelector('h2').textContent = photos ? 'Flores de verdad.' : 'Lo bonito también está en los detalles.';
            info.querySelectorAll('[data-fg-info-panel]').forEach(panel => { panel.hidden = (panel.dataset.fgInfoPanel === 'photos') !== photos; });
          }
          root.dataset.fgEditing = editing ? kind : '';
          editSnapshot = snapshot();
          if (kind === 'about') {
            aboutReturnHash = win.location.hash === ABOUT_HASH ? '' : win.location.hash;
            if (updateHash && win.location.hash !== ABOUT_HASH) setHash(ABOUT_HASH);
          }
          target.showModal();
          restoreScroll(position);
          target.scrollTop = 0;
          const infoScroll = target.querySelector('.fg-info-scroll');
          if (infoScroll) infoScroll.scrollTop = 0;
          root.dataset.fgDialog = 'true';
          if (['care', 'included'].includes(kind)) {
            const detail = target.querySelector('[data-fg-info-item="' + kind + '"]');
            target.querySelectorAll('details').forEach(item => { item.open = item === detail; });
            if (detail) win.requestAnimationFrame(() => { if (target.open && detail.isConnected) detail.scrollIntoView({ block: 'nearest' }); });
          }
          const panel = Array.from(target.querySelectorAll('[data-fg-panel]')).find(item => !item.hidden);
          const field = kind === 'note' ? panel?.querySelector('textarea') : panel?.querySelector('select, textarea, input');
          (field || target.querySelector('[data-fg-close]'))?.focus({ preventScroll: true });
          restoreAfterFocus(position, revision, () => target.open);
        }
        on(doc, 'pointerdown', () => { pointerScroll = null; }, { capture: true });
        on(root, 'pointerdown', event => {
          const opener = event.target?.closest?.('[data-fg-open]');
          if (!opener || opener.disabled || event.isPrimary === false || (event.button !== undefined && event.button !== 0)) return;
          pointerScroll = { trigger: opener, pointerId: event.pointerId, position: { x: win.scrollX || 0, y: win.scrollY || 0 } };
          // Form buttons can receive native focus before click, moving the scene.
          if (opener.matches('button') && opener.closest('form') && !event.target.closest('input, select, textarea')) {
            event.preventDefault();
            opener.focus({ preventScroll: true });
          }
        }, { capture: true });
        on(doc, 'pointerup', event => {
          const released = pointerScroll;
          if (!released) return;
          if (event.pointerId !== released.pointerId || event.target?.closest?.('[data-fg-open]') !== released.trigger) { pointerScroll = null; return; }
          // A matching click follows pointerup; discard a release that produces none.
          win.requestAnimationFrame(() => { if (pointerScroll === released) pointerScroll = null; });
        });
        on(doc, 'pointercancel', () => { pointerScroll = null; });
        on(doc, 'click', () => { pointerScroll = null; });
        on(root, 'click', event => {
          const target = event.target?.closest ? event.target : event.target?.parentElement;
          const opener = target?.closest('[data-fg-open]');
          if (opener) { event.preventDefault(); open(opener.dataset.fgOpen, opener, true, event.detail !== 0); return; }
          pointerScroll = null;
          const continueBlank = target?.closest('[data-fg-note-blank]');
          if (continueBlank) {
            event.preventDefault();
            const message = form.querySelector('[name="message"]'); if (message) message.value = '';
            form.dispatchEvent(new win.Event('change', { bubbles: true }));
            finishNoteReview(true); editor?.close(); return;
          }
          if (target?.closest('[data-fg-done]') && noteReview) {
            event.preventDefault();
            const message = form.querySelector('[name="message"]');
            if (!message?.value.trim()) { message?.focus({ preventScroll: true }); return; }
            finishNoteReview(true); editor?.close(); return;
          }
          const close = target?.closest('[data-fg-close]');
          if (close) { event.preventDefault(); close.closest('dialog')?.close(); }
        });
        root.querySelectorAll('dialog').forEach(dialog => {
          on(dialog, 'click', event => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          });
          on(dialog, 'close', () => {
            const anyOpen = !!root.querySelector('dialog[open]');
            root.dataset.fgDialog = String(anyOpen);
            if (!editor?.open) root.dataset.fgEditing = '';
            if (dialog === editor && !editor.open) finishNoteReview(false);
            if (dialog === about && !about.open) releaseAboutHash();
            if (!dialog.hasAttribute('data-fas-cart-dialog') && !anyOpen && trigger?.isConnected && !trigger.disabled) trigger.focus({ preventScroll: true });
            if (!dialog.open) {
              const position = modalScroll.get(dialog);
              modalScroll.delete(dialog);
              if (position && !anyOpen) restoreAfterFocus(position, ++scrollRevision, () => !root.querySelector('dialog[open]'));
            }
            if (dialog === editor && !anyOpen && editSnapshot !== snapshot()) root.dispatchEvent(new win.CustomEvent('fas:selection', { bubbles: true, detail: { source: 'confirmed-editor' } }));
          });
        });
        const observer = new win.MutationObserver(() => {
          root.dataset.fgDialog = String(!!root.querySelector('dialog[open]'));
          if (!editor?.open) root.dataset.fgEditing = '';
        });
        root.querySelectorAll('dialog').forEach(dialog => observer.observe(dialog, { attributes: true, attributeFilter: ['open'] }));
        function update() {
          const selection = new win.FormData(form), pair = selection.get('offer') !== 'single';
          const large = selection.get('offer') === 'pareja-xl' || (!pair && selection.get('size') === 'large');
          root.dataset.pair = String(pair); root.dataset.size = large ? '19' : '10';
          const label = root.querySelector('[data-fg-offer-label]');
          if (label) label.textContent = (pair ? large ? '2 grandes + & pequeño' : '2 pequeñas + &' : 'Una inicial') + ' · ' + (large ? '19' : '10') + ' cm ⌄';
          if (form.elements.letter2) { form.elements.letter2.disabled = !pair; form.elements.letter2.required = pair; }
          form.querySelectorAll('[name="tone2"]').forEach(element => { element.disabled = !pair; });
          const cost = root.querySelector('[data-fg-message-cost]');
          let catalog;
          try { catalog = JSON.parse(root.querySelector('[data-fas-catalog]').textContent); } catch (_) { /* Existing fallback keeps unavailable prices explicit. */ }
          const price = catalog?.products?.['mensaje-personalizado'];
          if (cost) cost.textContent = selection.get('offer') === 'pareja-xl' ? 'Incluida en el pack grande' : price?.available ? 'La tarjeta personalizada añade ' + new Intl.NumberFormat('es-ES', { style: 'currency', currency: catalog.currency }).format(price.price / 100) : 'Consultar disponibilidad';
        }
        on(form, 'input', event => {
          if (event.target?.name !== 'message') return;
          const toggle = form.querySelector('[name="noteEnabled"]');
          if (toggle && new win.FormData(form).get('offer') !== 'pareja-xl') { toggle.checked = !!event.target.value.trim(); form.dispatchEvent(new win.Event('change', { bubbles: true })); }
        });
        on(form, 'input', update); on(form, 'change', update); on(root, 'fas:selection', update);
        on(form, 'change', event => {
          // Native choice changes are actions; initialization and commerce refreshes are not.
          if (event.isTrusted === false || event.target?.disabled || !event.target?.matches?.('select, input, textarea')) return;
          const rect = event.target.getBoundingClientRect();
          event.target.dispatchEvent(new win.CustomEvent('fas:flower', { bubbles: true, detail: {
            source: 'personalization', clientX: rect.left + rect.width / 2, clientY: rect.top + rect.height / 2
          } }));
        });
        const offered = new URL(win.location.href).searchParams.get('oferta');
        if (['single', 'pareja', 'pareja-xl'].includes(offered)) {
          const radio = form.querySelector('input[name="offer"][value="' + offered + '"]');
          if (radio) { radio.checked = true; form.dispatchEvent(new win.Event('change', { bubbles: true })); }
        }
        function routeAbout() {
          if (win.location.hash === ABOUT_HASH) open('about', root.querySelector('[data-fg-open="about"]'), false);
          else if (about?.open) about.close();
        }
        on(win, 'hashchange', routeAbout); on(win, 'popstate', routeAbout);
        update();
        const instance = { open, reviewNote(button) {
          if (!editor || !done || !blank) return Promise.resolve(true);
          finishNoteReview(false); open('note', button);
          if (done) done.textContent = 'Guardar y añadir al carrito';
          blank.hidden = false;
          const copy = editor.querySelector('[data-fg-note-review-copy]'); if (copy) copy.hidden = false;
          return new Promise(resolve => { noteReview = resolve; });
        }, destroy() { finishNoteReview(false); abort.abort(); observer.disconnect(); closeAll(); restoreFooter(); instances.delete(root); } };
        instances.set(root, instance);
        const entry = root.dataset.entry;
        if (win.location.hash === ABOUT_HASH || new URL(win.location.href).pathname.endsWith('/pages/sobre-nosotros')) open('about', root.querySelector('[data-fg-open="about"]'), false);
        else if (entry === 'cart') root.querySelector('[data-fas-cart-open]')?.click();
        else if (entry === 'page') open('info', root.querySelector('[data-fg-open="info"]'));
      });
    }
    function destroy(scope = doc) {
      for (const [root, instance] of instances) if (scope === doc || scope === root || scope.contains?.(root) || root.contains?.(scope)) instance.destroy();
    }
    globalListener(doc, 'shopify:section:unload', event => destroy(event.target));
    globalListener(doc, 'shopify:section:load', event => { destroy(event.target); initialize(event.target); });
    if (doc.readyState === 'loading') globalListener(doc, 'DOMContentLoaded', () => initialize());
    else initialize();
    return { initialize, destroy, getController: root => instances.get(root), dispose() { if (disposed) return; disposed = true; destroy(); cleanups.splice(0).forEach(off => off()); } };
  }
  return { createEngine };
});
